import { mockConsultationDB } from './mockDb';
import type { Prescription, PrescriptionFormData, BillingPayload } from '../types';

export const prescriptionService = {
  async getAll(): Promise<Prescription[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockConsultationDB.getPrescriptions();
  },

  async getById(id: string): Promise<Prescription> {
    await new Promise(resolve => setTimeout(resolve, 100));
    const prescription = mockConsultationDB.getPrescription(id);
    if (!prescription) throw new Error('Prescription not found');
    return prescription;
  },

  async getByEncounter(encounterId: string): Promise<Prescription | null> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockConsultationDB.getPrescriptionByEncounter(encounterId) || null;
  },

  async getByDoctor(doctorId: string): Promise<Prescription[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    const allPrescriptions = mockConsultationDB.getPrescriptions();
    const doctorEncounters = mockConsultationDB.getEncounters().filter(e => e.doctorId === doctorId);
    const encounterIds = doctorEncounters.map(e => e.id);
    return allPrescriptions.filter(p => encounterIds.includes(p.encounterId));
  },

  async create(encounterId: string, data: PrescriptionFormData): Promise<Prescription> {
    await new Promise(resolve => setTimeout(resolve, 200));
    
    const encounter = mockConsultationDB.getEncounter(encounterId);
    const patientId = encounter?.patientId || data.patientId || '';
    
    return mockConsultationDB.createPrescription({
      ...data,
      encounterId,
      patientId,
    });
  },

  async update(id: string, data: Partial<PrescriptionFormData>): Promise<Prescription> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockConsultationDB.updatePrescription(id, data);
    if (!updated) throw new Error('Prescription not found');
    return updated;
  },

  async generateBillingPayload(prescriptionId: string): Promise<BillingPayload> {
    await new Promise(resolve => setTimeout(resolve, 100));
    const prescription = mockConsultationDB.getPrescription(prescriptionId);
    if (!prescription) throw new Error('Prescription not found');

    const items = prescription.items.map(item => ({
      name: item.nameOrMedicineId,
      qty: 1,
      price: 10.00,
    }));

    const total = items.reduce((sum, item) => sum + (item.price || 0), 0);

    return {
      items,
      total,
    };
  },
};
